
import React from "react";
import { Link } from "react-router-dom";
import { Card, CardDescription, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Agent } from "@/models/agent";

interface SimilarAgentsProps {
  agents: Agent[];
}

export const SimilarAgents: React.FC<SimilarAgentsProps> = ({ agents }) => {
  if (agents.length === 0) return null;
  
  return (
    <div className="mb-8">
      <h2 className="text-xl font-semibold mb-4">Similar Agents</h2>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {agents.map(agent => (
          <Card key={agent.id} className="overflow-hidden hover:shadow-md transition-shadow">
            <CardHeader className="p-4">
              <CardTitle className="text-lg">
                <Link to={`/agents/${agent.id}`} className="hover:text-primary transition-colors">
                  {agent.name}
                </Link>
              </CardTitle>
              <CardDescription className="line-clamp-2">
                {agent.description}
              </CardDescription>
            </CardHeader>
            <CardFooter className="p-4 pt-0 flex justify-between items-center">
              <Badge variant="outline">
                {agent.category}
              </Badge>
              <span className="text-sm font-medium">
                {agent.pricingModel === "free" ? (
                  <span className="text-green-600 dark:text-green-400">Free</span>
                ) : (
                  <span>$10.00</span>
                )}
              </span>
            </CardFooter>
          </Card>
        ))}
      </div>
    </div>
  );
};
